/** @jsx jsx */
import React from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { css } from '@emotion/core'

export default props => {
  const { children } = props
  const theme = useThemeUI()

  return <div
    sx={{
      variant: 'text.caps',
      bg: 'primary',
      pl: 1,
      pr: 1,
      pt: '2px',
      pb: '2px',
      borderRadius: 2,
      borderStyle: 0,
      borderWidth: 0,
      display: 'inline-block',

      span: {
        color: 'white',
        display: 'inline-block'
      }
    }}
    >
    <span>{ children }</span>
  </div>
}